export default __webpack_public_path__ + "static/media/007.65c61751.jpg";